export const riskFlagLabel = (value) => String(value || "")
  .toLowerCase()
  .split("_")
  .filter(Boolean)
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
  .join(" ");

export const sourceDecisionRequiresAcknowledgement = (value) => {
  const normalized = String(value || "").trim().toUpperCase().replace(/[ -]+/g, "_");
  return ["WAIT", "AVOID", "NO_TRADE", "NO_PLAY"].includes(normalized);
};

export const reviewedPublicFlags = (play) => play?.risk_reviewed === true
  ? [...new Set(play?.public_risk_flags || [])]
  : [];
